import { render, staticRenderFns } from "./GuestMobileOrderSheet.vue?vue&type=template&id=8b0dc4f6"
import script from "./GuestMobileOrderSheet.vue?vue&type=script&lang=js"
export * from "./GuestMobileOrderSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports